import { RoutersType } from "../type/routes";
import SCRD310001 from "../pages/SCRD310001";
import SCRC100006 from "../pages/SCRC100006";
import SCRC100005 from "../pages/SCRC100005";
import SCRC100004 from "../pages/SCRC100004";
import SCRC100003 from "../pages/SCRC100003";
import SCRC100002 from "../pages/SCRC100002";
import SCRC100001 from "../pages/SCRC100001";
import SCRD310002 from "../pages/SCRD310002";
import SCRD310003 from "../pages/SCRD310003";

/**
 * アプリケーションのルートオブジェクトの配列です。
 * @typedef {Object} RoutersType
 * @property {string} name - ルートの名前。
 * @property {string} path - ルートのパス。
 * @property {React.ComponentType} component - ルートにレンダリングするコンポーネント。
 */
const routes: RoutersType[] = [
  /**
   * 代行者ホームのルート情報
   */
  {
    name: "代行者ホーム",
    path: "/SCRD310001",
    component: SCRD310001,
    meta: {
      title: "代行者ホーム",
    },
  },
  {
    name: "代行者への処理依頼",
    path: "/SCRC100001",
    component: SCRC100001,
    meta: {
      title: "代行者への処理依頼",
    },
  },
  {
    name: "代行者の管理",
    path: "/SCRC100002",
    component: SCRC100002,
    meta: {
      title: "代行者の管理",
    },
  },
  {
    name: "代行者　新規登録",
    path: "/SCRC100003",
    component: SCRC100003,
    meta: {
      title: "代行者　新規登録",
    },
  },
  {
    name: "代行処理依頼詳細",
    path: "/SCRC100004",
    component: SCRC100004,
    meta: {
      title: "代行処理依頼詳細",
      contextName: "AgentRequest",
    },
  },
  {
    name: "代行者への新規依頼",
    path: "/SCRC100005",
    component: SCRC100005,
    meta: {
      title: "代行者への新規依頼",
    },
  },
  {
    name: "代行者への再依頼",
    path: "/SCRC100006",
    component: SCRC100006,
    meta: {
      title: "代行者への再依頼",
    },
  },
  {
    name: "依頼内容処理状況管理",
    path: "/SCRD310002",
    component: SCRD310002,
    meta: {
      title: "依頼内容処理状況管理",
    },
  },
  {
    name: "処理依頼履歴",
    path: "/SCRD310003",
    component: SCRD310003,
    meta: {
      title: "処理依頼履歴",
    },
  },
];

export { routes };
